export const Clients = (props) => {
  return (
    <div id="clients" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.title}</h2>
          <p>{props.paragraph}</p>
        </div>
        <div className="clients-grid">
          {props.list?.map((client, i) => (
            <div key={i} className={`client-tile${client.dark ? " client-tile-dark" : ""}`}>
              {client.logo ? (
                <img src={client.logo} alt={client.name} />
              ) : (
                <span className="client-tile-name">{client.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
